function displayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

export default {
  displayName,
};
